import type { WebhookProviderConfigViewProps } from '../types';
import { DefaultWebhookProviderConfigView } from './default-webhook-provider-config-view';

export const HubspotWebhookConfigView: React.FC<
  WebhookProviderConfigViewProps
> = (props) => {
  return <DefaultWebhookProviderConfigView {...props} />;
};
